var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFundraise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 75,
    viewBox: "0 0 78 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    className: "iconFundraise",
    fill: "currentColor",
    d: "M19.34 16.11a1.687 1.687 0 0 1 1.664.269l8.233 6.812c1.554-.585 2.386-1.07 3.457-1.454C36.019 27.279 42.088 31 49 31c5.065 0 9.677-1.999 13.089-5.248.618.472 1.24.976 1.88 1.51 3.885 3.238 6.334 7.48 7.213 12.429a4.993 4.993 0 0 1 1.967-.402c2.674 0 4.85 2.09 4.85 4.658 0 1.242-.503 2.41-1.416 3.29a1.66 1.66 0 0 1-1.154.458c-.413 0-.827-.15-1.144-.45a1.504 1.504 0 0 1-.009-2.196c.3-.29.473-.691.473-1.102 0-.856-.718-1.553-1.6-1.553-.883 0-1.601.697-1.601 1.553 0 5.187-1.764 10.105-5.102 14.223-1.947 2.402-4.676 8.195-6.134 13.83h3.708c.897 0 1.625.643 1.625 1.5 0 .858-.728 1.5-1.625 1.5H48.816c-.438 0-.857-.169-1.163-.468a1.516 1.516 0 0 1-.462-1.122c.044-1.747-.177-3.547-.371-5.136l-.062-.507c-4.993 1.167-9.01 1.434-12.91.856l-1.005 3.378h.62C34.361 72 35 72.643 35 73.5c0 .857-.638 1.5-1.536 1.5H16.011c-.898 0-1.65-.643-1.65-1.5s.752-1.5 1.65-1.5h4.29c.276-2.131.56-4.602.724-6.597-5.074-1.209-8.972-2.451-13.172-7.676H6.047c-1.223 0-2.867-.553-3.755-3.188L.404 48.93c-.633-1.882-.522-3.457.332-4.681.59-.845 1.829-1.895 4.389-2.101 1.667-.135 2.184-.301 2.997-3.166 1.424-5.016 4.41-8.703 9.113-11.248l1.088-10.338a1.564 1.564 0 0 1 1.017-1.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M23.563 34.667c-2.291 0-4.159 1.797-4.159 4 0 2.203 1.868 4 4.159 4 2.29 0 4.158-1.797 4.158-4 0-2.203-1.868-4-4.158-4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "iconFundraise",
    fill: "currentColor",
    d: "M49 0C42.39 0 37 5.393 37 12.002 37 18.61 42.389 24 49 24c6.61 0 12-5.39 12-11.998C61.001 5.392 55.61 0 49 0z",
    opacity: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFundraise);
export default __webpack_public_path__ + "static/media/icon-fundraise.4e4af988.svg";
export { ForwardRef as ReactComponent };